import { actionTypes as types } from '../constants'

const initialState = {
  isFetching: false,
  // Display error page
  fetchError: null,
  // Display success page
  fetchSuccessAction: '',
  // Display retry request page
  fetchRetry: null,
  // Array of addresses
  addresses: [],
}

const fetchingState = () => ({
  isFetching: true,
  fetchError: null,
  fetchSuccessAction: '',
})

const successState = (actionType) => ({
  isFetching: false,
  fetchRetry: null,
  fetchSuccessAction: actionType,
})

const failureState = () => ({
  isFetching: false,
  fetchSuccessAction: '',
})

function address(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_ADDRESSES:
      return {
        ...state,
        ...fetchingState(),
      }

    case types.FETCH_ADDRESSES_SUCCESS:
      return {
        ...state,
        ...successState(action.type),
        addresses: [...state.addresses, ...action.addresses],
      }

    case types.FETCH_ADDRESSES_FAILURE:
      return {
        ...state,
        ...failureState(),
        fetchError: action.fetchError,
        fetchRetry: action.fetchRetry,
      }

    default:
      return state
  }
}

export default address
